export const getTilesetById = (state, { tilesetId }) => state.editor.tilesets.collection[tilesetId];
